$('[data-toggle="tooltip"]').tooltip()